
import Form from 'react-bootstrap/Form';
import useCuentaBancaria from '../hooks/useCuentaBancaria';
import InputArchivo from './InputArchivo';

const CuentaBancaria = () => {

    const { cuenta, setCuenta, usaCuentaBancaria, setUsaCuentaBancaria, guardar,
        mostrarGuardar, setMostrarGuardar } = useCuentaBancaria();

    function mostrarInputCuenta() {
        if ( usaCuentaBancaria ) {
            return (
                <>
                    
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            value={ cuenta }
                            disabled={!mostrarGuardar}
                            className="form-control text-center"
                            aria-label="Indica el número de cuenta"
                            placeholder="Indica el número de cuenta"
                            onChange={ e => setCuenta( e.target.value ) }
                            aria-describedby="Indica el número de cuenta"
                        />
                        {!mostrarGuardar && <button className="btn btn-warning" type="button" id="Indica el número de cuenta" onClick={ () => setMostrarGuardar(true)}>Editar</button>}
                    </div>
                    <div>
                        <InputArchivo key="1" descripcion="Estado de cuenta o captura con número de cuenta cuenta BBVA" tipo="cuenta_bancaria"/>
                    </div>

                    { mostrarGuardar && <div className="d-flex justify-content-center col-6 mx-auto mt-3">
                        <button
                            type="button"
                            onClick={ guardar }
                            className="btn btn-primary"
                        >
                            Guardar
                        </button>
                    </div>}
                </>
            )
        }
    }

    return (
        <div>

            <p className="lead text-center">
                ¿Tiene cuenta en el banco BBVA?
            </p>

            <Form.Check
                id = 'usa_cuenta_bancaria'
                type = 'checkbox'
                className = 'd-flex justify-content-center no-select'
                checked = { usaCuentaBancaria }
                onChange = { e => setUsaCuentaBancaria( e.target.checked ) }
                label = '&nbsp;&nbsp;Marcar en caso de tener cuenta BBVA activa'
            />

            <div className='d-flex justify-content-center'>
                <div className='col-12 col-md-6'>
                    { mostrarInputCuenta() }
                </div>
            </div>

            <hr className='m-5'/>
        </div>
    )
}

export default CuentaBancaria
